import type { AIConfig } from '../../schema/ai-schema.js'
import { generatePromptSpec } from '../../generate-prompt.js'

export default ({
  title,
  lyrics,
  userConfig,
  promptText,
}: {
  /** Title of song/document */
  title: string
  style?: string
  lyrics: string
  userConfig?: AIConfig
  /** Pre-composed prompt body. When omitted, the lyrics-based default is used. */
  promptText?: string
}) => {
  const text =
    promptText ??
    `The song is called "${title}". The lyrics of the song are:

${lyrics}
`

  return generatePromptSpec({
    promptText: text,
    context: 'song:image',
    userConfig: userConfig?.contexts['song:image'],
  })
}
